import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { RejectPaymentParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  RejectPaymentRepository,
  PaymentActionResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum RejectPaymentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: RejectPaymentState;
  message: string;
}

const initialState: InitialState = {
  status: RejectPaymentState.initial,
  message: "",
};

export const rejectPayment = createAsyncThunk(
  "rejectPayment",
  async (param: RejectPaymentParam, { rejectWithValue }) => {
    try {
      const response: PaymentActionResponse =
        await RejectPaymentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  },
);

export const rejectPaymentSlice = createSlice({
  name: "rejectPayment",
  initialState,
  reducers: {
    resetRejectPayment: (state) => {
      state.status = RejectPaymentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rejectPayment.pending, (state) => {
        state.status = RejectPaymentState.inProgress;
      })
      .addCase(rejectPayment.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = RejectPaymentState.success;
          state.message = action.payload.message;
        }
      })
      .addCase(rejectPayment.rejected, (state, action) => {
        state.status = RejectPaymentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectRejectPayment = (state: RootState) => state.rejectPayment;
export const { resetRejectPayment } = rejectPaymentSlice.actions;
export default rejectPaymentSlice.reducer;
